module.exports = __webpack_public_path__ + "static/ios-appstore-badge-9c11beb9ef0115cd09d5d3dcf92e0d02.png";